import { createSlice } from "@reduxjs/toolkit";
import {      reKyc_UpdatePersonalDetailsThunk } from "./thunk";

export const initialState = {
  reKyc_UpdatePersonalDetailData: [],
  reKyc_UpdatePersonalDetailError: '', // for error message
  reKyc_UpdatePersonalDetailLoading: false,
  
  
};

const Re_Kyc_Update_Personal_Details = createSlice({
  name: "Re_Kyc_Update_Personal_Details",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(reKyc_UpdatePersonalDetailsThunk.pending, (state) => {
      state.reKyc_UpdatePersonalDetailLoading = true ;
      state.reKyc_UpdatePersonalDetailData= [];
      state.reKyc_UpdatePersonalDetailError='';

  });
    builder.addCase(reKyc_UpdatePersonalDetailsThunk.fulfilled, (state, action) => {
        state.reKyc_UpdatePersonalDetailData = action.payload.data;
        state.reKyc_UpdatePersonalDetailLoading = false ;
    });
    builder.addCase(reKyc_UpdatePersonalDetailsThunk.rejected, (state, action) => {
      state.reKyc_UpdatePersonalDetailError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.reKyc_UpdatePersonalDetailLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Re_Kyc_Update_Personal_Details.actions

export default Re_Kyc_Update_Personal_Details.reducer;